import { Gender } from '../enums/gender.enum';

export const GenderLabel = {
  [Gender.MALE]: 'Male',
  [Gender.FEMALE]: 'Female'
};
